<!-- Suscription Section  -->
<span hidden>
  {{ order$ | async }}
</span>

<ng-container *ngIf="order && isNotPaused; else Spinner">
  <ion-header>
    <ion-toolbar>
      <!-- Atrás -->
      <ion-buttons slot="start">
        <ion-button [disabled]="isLoading" (click)="onBack()">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

      <!-- Titulo -->
      <ion-title style="padding: 0">Pedido #{{ order.number.toString().padStart(4, '0') }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="container">
    <div class="content">
      <!-- Info? -->
      <div class="title">{{ title }}</div>
      <p class="body">{{ body }}</p>
      <p class="body" *ngIf="!isProcessPending" [innerHTML]="attention()"></p>

      <form *ngIf="this.isProcessPending" #ngForm="ngForm" [formGroup]="payloadPauseForm" (ngSubmit)="onSubmit()">
        <!-- <ion-item> -->
        <ion-label position="stacked">{{ commentTitle }}<ion-text color="danger">*</ion-text></ion-label>
        <ion-textarea
          class="textarea"
          formControlName="comment"
          type="text"
          required
          rows="4"
          auto-grow="true"
          [placeholder]="commentPlaceholder"
          [disabled]="isLoading"
        >
        </ion-textarea>
        <!-- </ion-item> -->
        <ng-container *ngTemplateOutlet="errorMmsg; context: { property: 'comment', ngForm: ngForm }"></ng-container>
      </form>
    </div>
  </ion-content>
  <ion-footer>
    <!-- Acciones -->
    <ion-row class="ion-justify-content-around p-20">
      <ion-button
        type="button"
        expand="block"
        *ngIf="this.isProcessPending"
        (click)="onSubmit()"
        [disabled]="isLoading || payloadPauseForm.invalid || !isProcessPending"
      >
        {{ confirm }}
      </ion-button>
      <ion-button type="button" expand="block" (click)="onBack()" fill="outline">
        {{ cancel }}
      </ion-button>
    </ion-row>
  </ion-footer>
</ng-container>

<!-- Template Section -->

<ng-template #errorMmsg let-property="property" let-ngForm="ngForm">
  <div class="error-container">
    <ng-container *ngFor="let validation of validationMessages[property]">
      <div
        class="error-message"
        *ngIf="
          payloadPauseForm.get(property).hasError(validation.type) &&
          (isDirty(property) || isTouched(property) || ngForm.submitted)
        "
      >
        <ion-icon name="information-circle-outline"></ion-icon>
        <span translate>{{ validation.message }}</span>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #Spinner>
  <ion-content style="margin: auto">
    <ion-row class="ion-justify-content-center ion-align-items-center" style="height: 25%">
      <ion-spinner></ion-spinner>
    </ion-row>
  </ion-content>
</ng-template>
